<div class="wikilink-popup" [style.top]="popupStyle().top" [style.left]="popupStyle().left">
  <!-- Header row -->
  <div class="popup-header">
    <div class="header-left">
      <img src="assets/icons/link.svg" class="icon-16 icon-text-secondary" alt="">
      <span class="p-small text-secondary">{{ 'wikilinkPopup.link' | t }}</span>
    </div>
    <div class="header-actions">
      @if (editable()) {
        <button class="icon-action-btn" (click)="removeWikilink()" [title]="'wikilinkPopup.removeLink' | t">
          <img src="assets/icons/document.svg" class="icon-18 icon-text-tertiary strikethrough-icon" alt="Unlink">
        </button>
      }
      @if (editable() && !isEditingSlug()) {
        <button class="edit-action-btn" (click)="startEditSlug()">
          <span class="p-small-semibold">{{ 'wikilinkPopup.edit' | t }}</span>
        </button>
      }
    </div>
  </div>

  <!-- Article preview / slug editor -->
  <div class="popup-body">
    @if (isEditingSlug()) {
      <!-- Slug editing mode -->
      <div class="slug-editor">
        <input
          class="slug-edit-input"
          type="text"
          [value]="slugInput()"
          (input)="onSlugInput($any($event.target).value)"
          (keydown)="onSlugKeydown($event)"
          (blur)="confirmSlugEdit()"
          [placeholder]="'wikilinkPopup.searchArticle' | t"
          spellcheck="false"
          autocomplete="off">
        
        <!-- Autocomplete dropdown -->
        @if (showDropdown()) {
          <div class="autocomplete-dropdown">
            @for (result of dropdownResults(); track result.slug; let i = $index) {
              <button
                class="dropdown-item"
                [class.selected]="selectedIndex() === i"
                (mousedown)="selectResult(result)">
                <img src="assets/icons/document.svg" class="icon-16 icon-text-tertiary" alt="">
                <div class="dropdown-item-content">
                  <span class="dropdown-title p-small-semibold notranslate" translate="no">{{ result.title }}</span>
                  <span class="dropdown-slug p-small text-tertiary notranslate" translate="no">{{ result.slug }}</span>
                </div>
              </button>
            }
          </div>
        }

        @if (loadingResults()) {
          <div class="autocomplete-dropdown">
            <div class="dropdown-loading p-small text-tertiary">{{ 'wikilinkPopup.searching' | t }}</div>
          </div>
        }
      </div>
    } @else {
      <!-- Article preview card -->
      <button class="article-preview" (click)="navigateToArticle()">
        <div class="preview-info">
          <span class="preview-title p-semibold" [class.broken]="!articleExists()">
            {{ articleTitle() }}
          </span>
          @if (!articleExists()) {
            <span class="preview-status p-small text-tertiary">{{ 'wikilinkPopup.notCreated' | t }}</span>
          } @else {
            <span class="preview-slug p-small text-tertiary">{{ slugInput() }}</span>
          }
        </div>
        <img src="assets/icons/chevron-right.svg" class="icon-16 icon-text-tertiary" alt="Go">
      </button>
    }
  </div>

  <!-- Display text section -->
  @if (editable()) {
    <div class="popup-footer">
      <div class="text-section">
        <img src="assets/icons/document.svg" class="icon-16 icon-text-tertiary" alt="">
        <span class="p-small text-tertiary">{{ 'wikilinkPopup.text' | t }}</span>
        @if (isEditingText()) {
          <input  
            class="text-edit-input"
            type="text"
            [value]="displayTextInput()"
            (input)="displayTextInput.set($any($event.target).value)"
            (keydown)="onTextKeydown($event)"
            (blur)="confirmTextEdit()"
            [placeholder]="'wikilinkPopup.customText' | t"
            spellcheck="false">
        } @else {
          <span class="current-text p-small">{{ displayTextInput() || articleTitle() }}</span>
          <button class="change-text-btn p-small" (click)="startEditText()">{{ 'wikilinkPopup.changeText' | t }}</button>
        }
      </div>
    </div>
  }
</div>
